import React, { useEffect, useState } from 'react';

import { Glyphicon } from 'react-bootstrap';
import moment from 'moment';

import { Attachment } from '../../../types/Activity';
import { mimeTypeToIconMap } from '../utils';
import Modal from '../../utils/ModalComponet';

type Props = {
  attachment: Attachment;
  onAttachmentDelete: (attachment: Attachment) => Promise<void>;
};

const ActivityAttachmentRow = (props: Props) => {
  const { attachment } = props;
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [uploadedAt, setUploadedAt] = useState<string>('');
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);

  useEffect(() => {
    setUploadedAt(moment(attachment.uploadedAt).format('MMM DD YYYY'));
  }, [attachment.uploadedAt]);

  const handleConfirmAttachmentDelete = async () => {
    setShowConfirmModal(true);
  };

  const handleAttachmentDelete = async () => {
    setIsDeleting(true);
    await props.onAttachmentDelete(attachment);
    setIsDeleting(false);
  };

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
  };

  return (
    <tr>
      <td>
        <i
          className={`fa ${
            mimeTypeToIconMap[attachment.mimeType] ||
            mimeTypeToIconMap['default']
          }`}
        />
        &nbsp;
        <a href={attachment.url} target='_blank' rel='noopener noreferrer'>
          {attachment.title}
        </a>
      </td>
      <td>{attachment.type}</td>
      <td>{uploadedAt}</td>
      <td className={'text-right'}>
        <button
          className={`btn btn-danger btn-sm ${isDeleting && 'btn--loading'}`}
          onClick={handleConfirmAttachmentDelete}
        >
          {!isDeleting && <i className={`fa fa-trash`} />}
          {isDeleting && <Glyphicon glyph='refresh' className='spinning' />}
        </button>
        <Modal
          open={showConfirmModal}
          closeModal={handleCloseConfirmModal}
          cancel={handleCloseConfirmModal}
          action={handleAttachmentDelete}
          actionButtonText={'Delete'}
          disabled={isDeleting}
        >
          <h4>Delete attachment</h4>
          <hr />
          <p>
            Are you sure you want to delete the &apos;{attachment.title}&apos;`
            attachment?
          </p>
        </Modal>
      </td>
    </tr>
  );
};

export default ActivityAttachmentRow;
